import { error } from "jquery";
import React, { Component, version } from "react";
import { PaymentHistory } from "../Admin/PaymentHistory/PaymentHistory";
import { ComboBox } from "../ComboBox";
import './module.css';

export class RegistrationForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: null,
            symthomSelected: [],
            covidSelected: [],
            clientId: -1,
            currentForm: '',
            imageBase64: '',
            isCamera: false,
            post: false,
            showButton: false,
            vaccine: [],
            userId: -1,
            showForm: true,
            basicSheet: false
        }
        this.getByEmail = this.getByEmail.bind(this);
    }

    componentDidMount() {
        switch (window.location.pathname.toLowerCase()) {
            case '/registro':
                if (parseInt(document.querySelector('input[name=core]').value) == -1) {
                    this.setState({ pathController: 'New', currentForm: 'Registro' });
                } else {
                    this.setState({ pathController: 'Update', currentForm: 'Registro', basicSheet: false });
                }
                break;
            case '/ficha-basico':
                this.setState({ pathController: 'New', currentForm: 'Basico', basicSheet: true });
                this.get('Basic');
                break;
            case '/ficha-avanzado':
                this.setState({ pathController: 'RegisterAdvance', currentForm: 'Avanzado', basicSheet: false });
                this.get('Advance');
                break;
            case '/ficha-pl':
                this.setState({ pathController: 'RegisterPL', currentForm: 'Pl', basicSheet: false });
                this.get('PL');
                break;
            default:
        }

        if (window.location.search.indexOf('email') != -1) {
            this.setState({ email: window.location.search.substring(window.location.search.indexOf('email')).replace('email=', '') });
            this.loadFormByEmail(window.location.search.substring(window.location.search.indexOf('email')).replace('email=', ''));
        }
    }

    pageIsValid(container) {
        var isValid = true;
        var required = document.querySelectorAll(`#${container} [required], #${container} [isrequired=true]`);
        if (required) {
            var scrollTop = false;
            required.forEach((e, i) => {
                var val;
                switch (e.type) {
                    case 'email':
                        val = e.value;
                        break;
                    case 'text':
                        val = e.value;
                        break;
                    case 'number':
                        val = e.value;
                        break;
                    case 'checkbox':
                        val = e.checked;
                        break;
                    case 'radio':
                        val = document.querySelectorAll(`input[name=${e.name}]:checked`).length > 0;
                        break;
                    case 'select-one':
                        val = e.value;
                        break;
                }

                if (!val) {
                    if (!e.parentElement.querySelector('.error-required')) {
                        var element = document.createElement('span');
                        element.className = 'error-required';
                        element.innerText = 'Este campo es obligatorio.'
                        e.parentElement.append(element)
                    }
                    isValid = false;
                    if (!scrollTop) {
                        e.focus();
                        scrollTop = true;
                    }
                } else if (e.parentElement.querySelector('.error-required')) {
                    e.parentElement.querySelector('.error-required').remove();
                }
            });
        }
        return isValid;
    }

    async nextTab(e) {

        switch (e.currentTarget.dataset.argument) {
            case 'tab1':
                if (this.pageIsValid(e.currentTarget.dataset.argument)) {
                    document.querySelector('.nav.nav-tabs li.active').setAttribute('class', '');
                    document.querySelector('#tab2Click').removeAttribute('disabled')
                    document.querySelector('#tab2Click').parentElement.setAttribute('class', 'active');
                    document.querySelector('#tab2Click').click();
                    window.scrollTo(0, 0);
                }
                break;
            case 'tab2':
                if (this.pageIsValid(e.currentTarget.dataset.argument)) {
                    document.querySelector('.nav.nav-tabs li.active').setAttribute('class', '');
                    document.querySelector('#tab3Click').removeAttribute('disabled')
                    document.querySelector('#tab3Click').parentElement.setAttribute('class', 'active');
                    document.querySelector('#tab3Click').click();
                    window.scrollTo(0, 0);
                }
                break;
            case 'tab3':
                if (this.pageIsValid(e.currentTarget.dataset.argument)) {
                    document.querySelector('.nav.nav-tabs li.active').setAttribute('class', '');
                    document.querySelector('#tab4Click').removeAttribute('disabled')
                    document.querySelector('#tab4Click').parentElement.setAttribute('class', 'active');
                    document.querySelector('#tab4Click').click();
                    window.scrollTo(0, 0);
                }
                break;
            case 'tab4':
                if (this.pageIsValid(e.currentTarget.dataset.argument)) {
                    document.querySelector('.nav.nav-tabs li.active').setAttribute('class', '');
                    document.querySelector('#tab5Click').removeAttribute('disabled')
                    document.querySelector('#tab5Click').parentElement.setAttribute('class', 'active');
                    document.querySelector('#tab5Click').click();
                    window.scrollTo(0, 0);
                }
                break;
            default:
        }
    }

    model() {
        return {
            //Tab 1
            Id: parseInt(document.querySelector('input[name=core]').value),
            Email: document.querySelector('input[name=email]').value,
            Name: document.querySelector('input[name=name]').value,
            Alias: document.querySelector('input[name=alias]').value,
            Age: parseInt(document.querySelector('input[name=age]').value),
            DocumentType: document.querySelector('#DocumentType').value,
            Identification: document.querySelector('input[name=identification]').value,
            City: document.querySelector('input[name=city]').value,
            Address: document.querySelector('input[name=address]').value,
            Contact: document.querySelector('input[name=contact]').value,
            Enroller: document.querySelector('input[name=enroller]').value,
            EnrollerNumber: document.querySelector('input[name=enrollerNumber]').value,
            EmergencyName: document.querySelector('input[name=emergencyName]').value,
            EmergencyNumber: document.querySelector('input[name=emergencyNumber]').value,
            //Tab2
            AcceptedCovid: document.querySelector('input[name=acceptedCovid]').checked,
            DataProcessing: document.querySelector('input[name=dataProcessing]').checked,
            //Tab3
            Gender: document.querySelector(`input[name=gender]:checked`) ? document.querySelector(`input[name=gender]:checked`).value : '',
            Pregnant: document.querySelector(`input[name=pregnant]:checked`) ? document.querySelector(`input[name=pregnant]:checked`).value : '',
            Sleep: document.querySelector(`input[name=sleep]`).value ? parseInt(document.querySelector(`input[name=sleep]`).value) : null,
            TherapyYearAgo: document.querySelector(`input[name=therapyYearAgo]:checked`) ? document.querySelector(`input[name=therapyYearAgo]:checked`).value : '',
            CurrentTherapy: document.querySelector(`input[name=currentTherapy]:checked`) ? document.querySelector(`input[name=currentTherapy]:checked`).value : '',
            Hospitalized: document.querySelector(`input[name=hospitalized]:checked`) ? document.querySelector(`input[name=hospitalized]:checked`).value : '',
            TakeMedication: document.querySelector(`input[name=takeMedication]:checked`) ? document.querySelector(`input[name=takeMedication]:checked`).value : '',
            NervousCollapse: document.querySelector(`input[name=nervousCollapse]:checked`) ? document.querySelector(`input[name=nervousCollapse]:checked`).value : '',
            PhysicalDisability: document.querySelector(`input[name=physicalDisability]`).value,

            OptionSymptom: JSON.stringify(this.state.symthomSelected),
            AnotherSymptom: document.querySelector(`input[name=AnotherSymptom]`).value,

            AnotherMedication: document.querySelector(`input[name=anotherMedication]`).value,
            AnotherNervous: document.querySelector(`input[name=anotherNervous]`).value,

            OptionCovid: JSON.stringify(this.state.covidSelected),
            AnotherCovid: document.querySelector(`input[name=anotherCovid]`).value,

            //Tab4
            MoneyPolicy: document.querySelector('input[name=moneyPolicy]').checked,
            //Tab5
            AcceptedTerms: document.querySelector('input[name=acceptedTerms]').checked,
            AcceptParticipe: document.querySelector('input[name=acceptParticipe]').checked,
            Questions: document.querySelector(`input[name=questions]`).value,

            //FICHA BÁSICO
            //PaymentBasic: document.querySelector(`input[name=promotional]:checked`) ? document.querySelector(`input[name=pregnant]:checked`).value : '',
            Vaccine: JSON.stringify(this.state.vaccine),
            AnotherVaccine: document.querySelector(`input[name=anotherVaccine]`).value,
            Dosis: parseInt(document.querySelector(`input[name=dosis]`).value),

            //AVANZADO
            Basics: null,
            Advances: document.querySelectorAll('input[name=advance]:checked')[0] ? document.querySelectorAll('input[name=advance]:checked')[0].value === "true" : null,
            PLs: document.querySelectorAll('input[name=pl]:checked')[0] ? document.querySelectorAll('input[name=pl]:checked')[0].value === "true" : null,
            ObsAdvance: document.querySelector('textarea[name=obsAdvance]') ? document.querySelector('textarea[name=obsAdvance]').value : null,
            ObsPl: document.querySelector('textarea[name=obsPl]') ? document.querySelector('textarea[name=obsPl]').value : null,

            ProcessBasic: document.querySelector('#ComboWrappBasicProcess select') && document.querySelector('#ComboWrappBasicProcess select').value ? parseInt(document.querySelector('#ComboWrappBasicProcess select').value) : null,
            ProcessAdvance: document.querySelector('#ComboWrappAdvanceProcess select') && document.querySelector('#ComboWrappAdvanceProcess select').value ? parseInt(document.querySelector('#ComboWrappAdvanceProcess select').value) : null,
            ProcessPl: document.querySelector('#ComboWrappPlProcess select') && document.querySelector('#ComboWrappPlProcess select').value ? parseInt(document.querySelector('#ComboWrappPlProcess select').value) : null,
            UserImage: this.state.imageBase64
        }
    }

    async ValidateFormBasic(e) {

        if (this.pageIsValid(e.currentTarget.dataset.argument)) {
            document.querySelector('#auxBtnEnviar').click();
        }

    }

    async sendInfo(e) {

        console.log('v3');

        if (document.querySelector('#closeModalBasic')) {
            document.querySelector('#closeModalBasic').click();
        }

        if (this.pageIsValid(e.currentTarget.dataset.argument)) {
            var model = this.model();
            model.Basics = e.currentTarget.dataset.argument == 'tab5' ? true : null;

            if (document.querySelector('input[name=createdOnDate]').value) {
                model.CreatedOnDate = document.querySelector('input[name=createdOnDate]').value;
            }

            this.setState({ post: true });

            this.setState({ loading: true, post: true });

            var option = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify(model)
            };


            var response = await fetch(`Register/${this.state.pathController}`, option)
            const data = await response.json();
            if (response.status == 200) {

                if (!model.Basics) {
                    this.setState({ showPhoto: false, showForm: false, showOtp: false, successRegister: true });
                } else {
                    this.setState({ showOtp: data.showOtp, userId: data.id, showForm: false, showPhoto: data.showPhoto });
                }
            } else {
                alert(data.message);
            }
            this.setState({ loading: false, post: false });
        }

    }

    handleSymthom(e) {

        var select = this.state.symthomSelected;
        if (e.currentTarget.checked && select.indexOf(e.currentTarget.value) == -1) {
            select.push(e.currentTarget.value);
        }
        else if (!e.currentTarget.checked && select.indexOf(e.currentTarget.value) != -1) {
            select.splice(select.indexOf(e.currentTarget.value), 1);
        }

        this.setState({ symthomSelected: select });
    }


    handleCovid(e) {

        var select = this.state.covidSelected;
        if (e.currentTarget.checked && select.indexOf(e.currentTarget.value) == -1) {
            select.push(e.currentTarget.value);
        }
        else if (!e.currentTarget.checked && select.indexOf(e.currentTarget.value) != -1) {
            select.splice(select.indexOf(e.currentTarget.value), 1);
        }

        this.setState({ covidSelected: select });
    }

    handleVaccine(e) {
        var select = this.state.vaccine;
        if (e.currentTarget.checked && select.indexOf(e.currentTarget.value) == -1) {
            select.push(e.currentTarget.value);
        }
        else if (!e.currentTarget.checked && select.indexOf(e.currentTarget.value) != -1) {
            select.splice(select.indexOf(e.currentTarget.value), 1);
        }

        this.setState({ vaccine: select });
    }

    showButtonRegister(data) {

        switch (window.location.pathname.toLowerCase()) {
            case '/registro':

                return (
                    <div className="section-basic">
                        <div className="group-form col-lg-6">
                            <input type="button" value="Siguiente" onClick={this.nextTab.bind(this)} className="btn btn-primary" data-argument="tab1" />
                        </div>
                    </div>)
                break;
            case '/ficha-basico':
                return (
                    <div className="section-basic">
                        <div class="modal fade" id="closeLetterModal" tabindex="-1" role="dialog" aria-labelledby="closeLetterModal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLabel">Informaci&oacute;n importante</h5>
                                        <button type="button" id="closeModalBasic" class="closeModal" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body group-form">

                                        <div className="form-group">
                                            Valor de la matricula Entrenamiento Básico: $695.000 (Seiscientos noventa y cinco mil pesos Colombianos).
                                        </div>
                                        <div className="form-group">
                                            Valor de la matricula Entrenamiento Avanzado: $850.000 (Ochocientos cincuenta mil pesos Colombianos).
                                        </div>
                                        <div className="form-group">
                                            Valor de la matricula Entrenamiento PL: $1.650.000 (Millón seiscientos cincuenta mil pesos Colombianos).
                                        </div>
                                        <div className="form-group">
                                            El valor mínimo de inscripción al Taller es de $200.000 (Doscientos cincuenta mil pesos colombianos). Por debajo de ese valor NO se realiza ningún tipo de devolución.
                                        </div>
                                        <div className="form-group">
                                            En caso de NO asistir al Taller al que fue inscrito, deberá realizar la cancelación de su asistencia con un lapso de tiempo NO menor de 4 (Cuatro) días a la fecha de realización de éste (No podrá solicitarse reembolso de dinero, en caso de NO cumplir con el tiempo contemplado en ésta cláusula).
                                        </div>
                                        <div className="form-group">
                                            En caso tal de requerir transferencia de cupo, solo se podrá hacer únicamente de Taller a Taller: ejem Básico a Básico.
                                        </div>
                                        <div className="form-group">
                                            En caso de solicitar la devolución de dinero debe ajustarse a nuestras políticas de reembolso.
                                        </div>
                                        <div className="form-group">
                                            Si su valor pagado es por concepto PROMO, debe ajustarse a nuestras políticas de devolución y manejos de dinero.
                                        </div>
                                        <div >
                                            De conformidad con la Ley Estatutaria 1581 de 2012 de Protección de Datos y con el Decreto 1377 de 2013, autorizo expresamente, como titular de los datos, que éstos sean incorporados en la base de datos de la marca LIFE CENTRO DE ENTRENAMIENTO, para que sean tratados con la finalidad de realizar la inscripción a la FORMACION INTEGRAL Y DE TRANSFORMACION y todo lo que conlleva éste proceso.; En caso de que usted no desee recibir información debe manifestarlo en forma escrita.
                                        </div>
                                        <div className="form-group">
                                            Para conocer nuestras políticas de devolución y manejo de dineros visita nuestra página web: www.lifemedellin.com/registro
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <input type="button" value="Aceptar" onClick={this.sendInfo.bind(this)} className="btn btn-primary" data-argument="tab1" />
                                        <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cancelar</button>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="group-form col-lg-6" hidden>Desuso
                            <input type="radio" id="promotional-1" name="promotional" value="Promocional" onClick={() => { alert('Estas realizando pago promocional') }} />
                            <label for="promotional-1">Pago con código promocional</label>
                            <br />
                            <input type="radio" id="complete-1" name="promotional" value="Completo" />
                            <label for="complete-1">Pago completo</label>
                        </div>
                        <div className="group-form col-lg-6">
                            <label>* Básico al que vas a asistir</label>
                            <ComboBox data={this.state.dataProcess} id="ComboWrappBasicProcess" lot={false} isRequired="true" selectedValue={data ? data.processBasic : null} />
                        </div>
                        <div className="group-form col-lg-6">

                            <input type="button" value="Enviar" class="btn btn-primary" onClick={this.ValidateFormBasic.bind(this)} data-argument="tab1">

                            </input>
                            <input type="button" id="auxBtnEnviar" class="btn btn-primary" data-toggle="modal" data-target="#closeLetterModal" hidden>

                            </input>

                        </div>
                    </div>
                )
                break;
            case '/ficha-avanzado':
                return (
                    <div className="section-advance">
                        <div className="group-form col-lg-6">
                            <label>* Avanzado al que vas a asistir</label>
                            <ComboBox data={this.state.dataProcess} id="ComboWrappAdvanceProcess" lot={false} isRequired="true" />
                        </div>
                        <div className="group-form col-lg-6">
                            <label for="advanceYes">
                                <input type="radio" id="advanceYes" name="advance" value="true" className="form-control" /> S&iacute;
                            </label>
                            <label for="advanceNo">
                                <input type="radio" id="advanceNo" name="advance" value="false" className="form-control" /> No
                            </label>
                        </div>
                        <div className="group-form col-lg-6">
                            <label>Observaciones</label>
                            <textarea maxLength="500" name="obsAdvance" className="form-control"></textarea>
                        </div>
                        <div className="group-form col-lg-6">
                            <input type="button" value="Enviar" onClick={this.sendInfo.bind(this)} className="btn btn-primary" data-argument="tab1" />
                        </div>
                    </div>
                )
                break;
            case '/ficha-pl':
                return (
                    <div className="section-pl">
                        <div className="group-form col-lg-6">
                            <label>* Pl al que vas a asistir</label>
                            <ComboBox data={this.state.dataProcess} id="ComboWrappPlProcess" lot={false} isRequired="true" />
                        </div>
                        <div className="group-form col-lg-6">
                            <label for="plYes">
                                <input type="radio" id="plYes" name="pl" value="true" className="form-control" /> S&iacute;
                            </label>
                            <label for="plNo">
                                <input type="radio" id="plNo" name="pl" value="false" className="form-control" /> No
                            </label>
                        </div>
                        <div className="group-form col-lg-6">
                            <label>Observaciones</label>
                            <textarea maxLength="500" name="obsPl" className="form-control"></textarea>
                        </div>
                        <div className="group-form col-lg-6">
                            <input type="button" value="Enviar" onClick={this.sendInfo.bind(this)} className="btn btn-primary" data-argument="tab1" />
                        </div>
                    </div>
                )
                break;
            default:
        }
    }

    async getByEmail(e) {
        if (e.currentTarget && e.currentTarget.value) {

            this.setState({ loading: true });
            this.state.email = e.currentTarget.value;
            var options = {
                method: "GET",
                headers: {
                    'Content-type': 'application/json'
                }
            }
            const response = await fetch(`Register/GetByEmail?email=${e.currentTarget.value}`, options);

            if (response.status == 400 || response.status == 500) {
                this.setState({ data: null, showButton: false });
                alert('Error validando el correo electrónico, inténtelo más tarde.');
            } else {
                this.setState({ showButton: true, data: null });
                let data = response.status == 200 ? await response.json() : null;
                if (data) {
                    alert('Tu correo ya está registrado en nuestra base de datos, por favor presione "aceptar", revisa que  los datos que te van a aparecer estén correctos y haz clic en "Siguiente" para continuar con tu inscripción');
                    this.setState({ data: data });
                }
            }
            //document.querySelector('#tab1Click').click();
            this.setState({ loading: false });
        }
    }

    async loadFormByEmail(e) {
        this.setState({ loading: true });
        var options = {
            method: "GET",
            headers: {
                'Content-type': 'application/json'
            }
        }
        const response = await fetch(`Register/GetByEmail?email=${e}`, options);
        if (response.status == 200) {
            let data = await response.json();
            if (data) {
                alert('Tu correo ya está registrado en nuestra base de datos, por favor presione "aceptar", revisa que  los datos que te van a aparecer estén correctos y haz clic en "Siguiente" para continuar con tu inscripción.');
                this.setState({ data: data, showButton: true });
            }
        }
        //document.querySelector('#tab1Click').click();
        this.setState({ loading: false });
    }

    async get(type) {

        this.setState({ loading: true });

        var options = {
            method: "GET",
            headers: {
                'Content-type': 'application/json'
            }
        }
        const response = await fetch(`Register/Get?type=${type}`, options);
        if (response.status == 200) {
            let data = await response.json();
            if (data) {
                this.setState({ dataProcess: data });
            }
        }
        this.setState({ loading: false });
    }

    selectedImage(e) {
        if (e.currentTarget.files.length > 0) {
            this.getBase64(e.currentTarget.files[0])
        }
    }

    accessCamera() {

        this.setState({ isCamera: true });

        var video = document.getElementById('video');

        // Get access to the camera!
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            // Not adding `{ audio: true }` since we only want video now
            navigator.mediaDevices.getUserMedia({ video: true }).then(function (stream) {
                //video.src = window.URL.createObjectURL(stream);
                video.srcObject = stream;
                video.play();
            });
        }
        document.querySelector('#snap').focus();
    }

    screenSnap() {
        // Elements for taking the snapshot
        var canvas = document.getElementById('canvas');
        var context = canvas.getContext('2d');
        var video = document.getElementById('video');

        context.drawImage(video, 0, 0, 320, 240);

        let base64 = context.canvas.toDataURL();
        this.setState({ imageBase64: base64, isCamera: false });
        document.querySelector('#viewImage').focus();

        // Trigger photo take
        //document.getElementById("snap").addEventListener("click", function () {
        //    context.drawImage(video, 0, 0, 640, 480);
        //});
    }

    getBase64(file) {
        var context = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            context.setState({ imageBase64: reader.result });
        };
        reader.onerror = function (error) {
            alert("Error subiendo imagen, por favor inténtelo de nuevo.")
        };
    }

    async GenerateOtp(e) {

        e.preventDefault();
        this.setState({ loading: true });

        var options = {
            method: "POST",
            headers: {
                'Content-type': 'application/json'
            }
        }
        const response = await fetch(`Register/GenerateOtp?id=${this.state.userId}`, options);
        const data = await response.json();
        if (response.status == 200) {
            alert('El código otp ha sido generado correctamente y se ha enviado por correo y SMS');
        } else {
            alert(data.message);
        }
        this.setState({ loading: false });
    }

    async validateOtp() {

        this.setState({ loading: true });

        var options = {
            method: "POST",
            headers: {
                'Content-type': 'application/json'
            }
        }

        const response = await fetch(`Register/validateOtp?id=${this.state.userId}&code=${this.state.otpCode}`, options);
        let data = await response.json();
        if (response.status == 200) {
            this.setState({ showPhoto: true });
        } else {
            alert(data.message);
        }
        this.setState({ loading: false });
    }

    async savePhoto() {

        this.setState({ post: true });

        if (!this.state.imageBase64) {
            return;
        }

        this.setState({ loading: true });

        var model = { Id: this.state.userId, UserImage: this.state.imageBase64 };

        var options = {
            method: "POST",
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(model)
        }

        const response = await fetch(`Register/SavePhoto`, options);
        let data = await response.json();
        if (response.status == 200) {
            this.setState({ showPhoto: false, successRegister: true });
        } else {
            alert(data.message);
        }
        this.setState({ loading: false });
    }

    static renderForm(data, context) {

        if (context.state.successRegister) {
            return (
                <div className="text-center r-success-page">

                    <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
                        <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                        <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                    </svg>

                    <div class="alert alert-success alert-dismissible fade show">
                        <strong>¡Éxito!</strong> Su registro se ha completado correctamente.
                    </div>

                    <input type="button" class="btn btn-success" onClick={() => { window.location.reload(); }} value="Nuevo registro"></input>
                </div>
            )
        }

        if (context.state.showPhoto) {
            return (
                <div className="row">

                    <div className="col-sm-6 r-img">
                        <img src={require('../../images/basico.jpg')} />
                    </div>

                    <div className="col-sm-6">
                        <div className="group-form">
                            <h2>¡Queremos conocerte!</h2>
                            <label className="r-form-desc">* Puedes subir o tomarte una foto.</label>

                        </div>
                        <div className="group-form">
                            <div className="group-form">
                                <img id="viewImage" src={context.state.imageBase64} width="320" height="240" style={context.state.imageBase64 ? { display: "block" } : { display: 'none' }} />
                                <input id="fileImage" type="file" accept="image/*" onChange={(e) => { context.selectedImage(e) }} hidden />
                            </div>

                            <div className="group-form wrapp-file-cam">
                                <input type="button" className="file" onClick={() => { context.setState({ isCamera: false }); document.querySelector('#fileImage').click() }} />
                                <input type="button" className="camera" onClick={(e) => { context.accessCamera() }} />
                            </div>

                            <div className="group-form" style={context.state.isCamera ? { display: "block" } : { display: 'none' }} >
                                <video id="video" width="320" height="240" autoplay></video>
                                <br />
                                <button id="snap" className="btn btn-success" onClick={() => { context.screenSnap() }}>Tomar foto</button>
                                <canvas id="canvas" width="320" height="240" hidden></canvas>
                            </div>
                            {!context.state.imageBase64 && context.state.post ? <span className="error-required">Este campo es obligatorio.</span> : null}
                        </div>
                        <div>
                            <input type="button" className="btn btn-primary" value="Guardar foto" onClick={() => { context.savePhoto() }}></input>
                        </div>
                    </div>
                </div>
            )
        }

        if (context.state.showOtp) {
            return (


                <div>
                    <div class="alert alert-info">
                        <strong>Información</strong> Su registro ha sido guardado con éxito. Para confirmar su identidad, debe ingresar el código de 6 digitos enviado al correo y/o celular registrado.
                    </div>

                    <div class="card text-center">
                        <div class="card-header" hidden>
                            Validar código
                        </div>
                        <div class="card-body">

                            <h2>Código OTP</h2>
                            <input type="password" id="inputPassword5" class="form-control w-25 p-3 mx-auto" aria-describedby="passwordHelpBlock" maxLength="6" onChange={(e) => { context.setState({ otpCode: e.currentTarget.value }) }}></input>
                            <p class="card-text">Clic <a href="#" onClick={(e) => { context.GenerateOtp(e) }}>aquí</a> para generar un código nuevo</p>
                            {
                                context.state.otpCode && context.state.otpCode.length >= 4 ?
                                    <input type="button" className="btn btn-primary" value="Confirmar código" onClick={() => { context.validateOtp() }}></input>
                                    : null
                            }
                        </div>
                        <div class="card-footer text-muted">
                            Antes de solicitar un nuevo código, por favor verificar la bandeja de correos no deseados o SPAM
                        </div>
                    </div>
                </div >
            )
        }

        if (context.state.showForm) {
            return (
                <div>
                    <h2>Formulario de registro</h2>

                    {window.location.pathname.toLowerCase() === '/registro' ? <ul class="nav nav-tabs" >
                        <li class="active"><input type="button" data-toggle="tab" href="#tab1" id="tab1Click" value="1" /></li>
                        <li><input type="button" data-toggle="tab" href="#tab2" id="tab2Click" disabled="disabled" value="2" /></li>
                        <li><input type="button" data-toggle="tab" href="#tab3" id="tab3Click" disabled="disabled" value="3" /></li>
                        <li><input type="button" data-toggle="tab" href="#tab4" id="tab4Click" disabled="disabled" value="4" /></li>
                        <li><input type="button" data-toggle="tab" href="#tab5" id="tab5Click" disabled="disabled" value="5" /></li>
                    </ul> : null}

                    <div className="wrapp-form tab-content">
                        <div id="tab1" className="tab-pane fade in active show">
                            <input type="hidden" name="core" value={data ? data.id : -1} />
                            <input type="hidden" name="createdOnDate" value={data ? data.createdOnDate : null} />
                            <div className="group-form col-lg-6">
                                <label>* Correo electrónico</label>
                                <input defaultValue={context.state.email} type="email" name="email" className="form-control" required maxLength="100" onBlur={context.getByEmail.bind(this)} />
                            </div>
                            <div className="group-form col-lg-6">
                                <label>* Nombre completo</label>
                                <input defaultValue={data ? data.name : null} type="text" name="name" className="form-control" required maxLength="50" />
                            </div>
                            <div className="group-form col-lg-6">
                                <label>* Escribe el nombre que va a llevar tu escarpela</label>
                                <input defaultValue={data ? data.alias : null} type="text" name="alias" className="form-control" required maxLength="10" />
                            </div>
                            <div className="group-form col-lg-6">
                                <label>* Edad</label>
                                <input defaultValue={data ? data.age : null} type="number" name="age" className="form-control" required maxLength="3" />
                            </div>
                            <div className="group-form col-lg-6">
                                <select className="form-control" id="DocumentType" required>
                                    <option value="">Seleccione una opción</option>
                                    <option value="Cédula" selected={data ? (data.documentType == 'Cédula' ? true : false) : false}>Cédula</option>
                                    <option value="NIT" selected={data ? (data.documentType == 'NIT' ? true : false) : false}>NIT</option>
                                    <option value="Cédula de extranjería" selected={data ? (data.documentType == 'Cédula de extranjería' ? true : false) : false}>Cédula de extranjería</option>
                                </select>
                            </div>
                            <div className="group-form col-lg-6">
                                <label>* Cédula de ciudadania</label>
                                <input defaultValue={data ? data.identification : null} type="number" name="identification" className="form-control" required maxLength="10" />
                            </div>
                            <div className="group-form col-lg-6">
                                <label>* Ciudad de residencia</label>
                                <input defaultValue={data ? data.city : null} type="text" name="city" className="form-control" required maxLength="50" />
                            </div>
                            <div className="group-form col-lg-6">
                                <label>* Dirección de residencia</label>
                                <input defaultValue={data ? data.address : null} type="text" name="address" className="form-control" required maxLength="100" />
                            </div>
                            <div className="group-form col-lg-6">
                                <label>* ¿En qué número de teléfono podemos ponernos en contacto contigo?</label>
                                <input defaultValue={data ? data.contact : null} type="number" name="contact" className="form-control" required maxLength="15" />
                            </div>
                            <div className="group-form col-lg-6">
                                <label>* Ahora queremos saber quién te invito a vivir este entrenamiento, ¿cuál es su nombre y apellido?</label>
                                <input defaultValue={data ? data.enroller : null} type="text" name="enroller" className="form-control" required maxLength="100" />
                            </div>
                            <div className="group-form col-lg-6">
                                <label>* ¿cuál es el número de contacto de la persona que te invitó?</label>
                                <input defaultValue={data ? data.enrollerNumber : null} type="number" name="enrollerNumber" className="form-control" required maxLength="100" />
                            </div>
                            <div className="group-form col-lg-6">
                                <label>* EN CASO DE EMERGENCIA: ¿con quién quieres que nos comuniquemos?, ¿Cuál es su nombre?</label>
                                <input defaultValue={data ? data.emergencyName : null} type="text" name="emergencyName" className="form-control" required maxLength="100" />
                            </div>
                            <div className="group-form col-lg-6">
                                <label>* EN CASO DE EMERGENCIA: ¿Cuál es el número de tu contacto? </label>
                                <input defaultValue={data ? data.emergencyNumber : null} type="text" name="emergencyNumber" className="form-control" required maxLength="15" />
                            </div>

                            {context.state.showButton ? context.showButtonRegister(data) : null}

                        </div>
                        <div id="tab2" class="tab-pane fade">
                            <div className="group-form">
                                <div className="welcome">
                                    <span className="title">¡BIENVENIDO!</span>
                                    <span className="desc">Es momento de vivir un Entrenamiento único para ti</span>
                                </div>
                            </div>
                            <div className="group-form">
                                <h3><b>Información para ti...</b></h3>
                                <p>
                                    Gracias por participar en <b>Life C.E.L</b>. Es un placer servirle y poder brindarle unas herramientas que le apoyarán para toda su vida. Te invitamos a participar efectivamente en los ejercicios, experimentando directamente su propio descubrimiento y aprendizaje. Nuestros talleres son un programa educativo con base en experiencias diseñados para realzar la efectividad personal y el nivel de satisfacción en sus vidas.
                                </p>

                                <p>
                                    No tienen la intención de ser psicoterapia, consejería, sustituto o alternativa para psicoterapia, tampoco es un grupo de apoyo psicológico. Nuestros talleres no han sido diseñados para atender desbalances psicológicos, y su personal no está integrado por profesionales de salud mental capacitados para proveer tratamiento a personas con problemas psicológicos y emocionales. Si tales servicios son los que busca o necesita, nuestros talleres no le pueden servir.
                                </p>

                                <p>
                                    Las personas que equivocadamente asuman estos cursos como una alternativa a la terapia podrían experimentar consecuencias adversas. Si usted padece o piensa que podría padecer de un problema que requiere tratamiento psicológico, por favor no concurra a nuestros talleres.
                                    Si usted sufre traumas de la niñez a causa de castigo corporal, abuso sexual, u otras formas de violencia emocional, le instamos a que no trate de resolverlos por medio de su participación en nuestros talleres, porque estos no han sido diseñados para discernir problemas que son resultado de esos traumas, ni el sufrimiento que aún pueda estar experimentando.
                                    Los talleres se enfocan en su vida adulta no su niñez.
                                </p>

                                <p>
                                    Es probable que personas que han tenido una niñez dolorosa logren completar con éxito nuestros talleres al decidir, previamente, que no abordarán esos asuntos durante el taller. Sin embargo, en algunos momentos del entrenamiento podría, eventualmente, hacer que emerjan las memorias dolorosas. De este modo, le solicitamos que considere las implicaciones  de aquellas memorias tempranas antes de decir sobre la participación en nuestras actividades.
                                    Por lo tanto, le recomendamos que si está en algún tipo de tratamiento psicológico o psiquiátrico complete el mismo antes de iniciar nuestros talleres, o consulte con el profesional competente para que le autorice.
                                </p>

                                <p>
                                    Comuníquese con nosotros para discutir con los interrogantes que pueda tener. La decisión final será solo suya.
                                </p>
                            </div>
                            <div className="group-form">
                                <h3><b> RECOMENDACIONES Y REGLAS DEL ENTRENAMIENTO...</b></h3>
                                <p>
                                    INDICACIÓN COVID-19, Si durante tus días de preparación para vivir este entrenamiento presentas algunos de los síntomas señalados por la organización mundial de la salud (OMS), le recomendamos no realizar el entrenamiento y aplazarlo para una fecha diferente.
                                </p>

                                <p>
                                    Durante los días del entrenamiento es importante que obtenga suficiente descanso y buena nutrición.  Asegúrese de obtener suficientes horas de sueño y de ingerir alimentos sustanciosos antes de asistir al entrenamiento, y mantenerse suficientemente hidratado. Esta es su responsabilidad, si piensa que debido a su itinerario no podrá obtener el debido sueño y la correcta alimentación, le recomendamos que planifique su participación para una nueva fecha.
                                </p>

                                <p>
                                    Asimismo, para maximizar la experiencia del entrenamiento absténgase de ingerir alcohol o cualquier droga no recetada durante el periodo que este dure. Si sufre dependencia del alcohol, marihuana, cocaína y/o similares, u otra droga no recetada, o tendría dificultad para abstenerse durante el período de duración del entrenamiento, el recomendamos que no participe, ya que estos no han sido diseñados para ayudarle a resolver tales dependencias.
                                </p>

                                <p>
                                    Con el objetivo de que su experiencia en el entrenamiento sea más agradable lo invitamos a tener en cuenta las siguientes reglas que complementan las que se indiquen para cada nivel, y/o según las exigencias de cada coach:
                                </p>

                                <p>
                                    1. Mantenga completa confidencialidad sobre las experiencias, palabras y acciones de los compañeros participantes. LIFE C.E.L no se responsabiliza del manejo de esta información.
                                </p>
                                <p>
                                    2. Participe en todas las sesiones del entrenamiento y acuda puntualmente.
                                </p>
                                <p>
                                    3. No ingiera alimentos, ni mastique chicle o fume cigarrillo en el salón o lugar donde se esté desarrollando el entrenamiento.
                                </p>
                                <p>
                                    4. No consuma alcohol, marihuana, cigarrillo, cocaína y/o otras drogas similares no recetadas.
                                </p>
                                <p>
                                    5. No distraiga, ni hable con las personas que tiene cerca. Solo comparta sus experiencias cuando el entrenador se lo indique y por lo períodos recomendados.
                                </p>
                                <p>
                                    6. Use el gafete con su nombre en un lugar visible, y durante todo el entrenamiento.
                                </p>
                                <p>
                                    7. Está prohibido, so pena, de expulsión de la actividad sin que haya lugar a devolución de dinero  fotografiar, grabar, filmar o reproducir por cualquier medio o en cualquier formato el entrenamiento.
                                </p>
                                <p>
                                    8. Apague su celular, tablet, computador o cualquier aparato electrónico que pueda distraerlo durante el entrenamiento.
                                </p>
                                <p>
                                    9. No se ubique al lado de personas que conozca desde antes del entrenamiento.
                                </p>
                                <p>
                                    10. Sea responsable de su bienestar. Si está bajo tratamiento médico, indique en cuáles momentos debe tomar los medicamentos recetados.
                                </p>
                            </div>
                            <div className="group-form">
                                <label>* ¿Estás de acuerdo con la información anterior?
                                    De no estar de acuerdo con lo aquí mencionado, te invitamos a que te pongas en contacto con nosotros
                                </label>
                            </div>
                            <div className="group-form">
                                <label className="ie-check" for="acceptedCovid">
                                    <input type="checkbox" name="acceptedCovid" id="acceptedCovid" required className="form-control" /> <b>Acepto</b>
                                </label>
                            </div>
                            <div className="group-form">
                                <b>TÉRMINOS Y CONDICIONES PARA EL TRATAMIENTO DE DATOS CENTRO DE ENTRENAMIENTO EN LIDERAZGO LIFE-C.E.L</b>
                                <p>Como participante del curso organizado por LIFE CENTRO DE ENTRENAMIENTO EN LIDERAZGO - C.E.L los autorizo de manera, previa, expresa y libre, para que directamente, o a través de sus empleados, consultores, asesores y/o terceros encargados lleve a cabo el tratamiento seguro, fidedigno y confidencial de mis datos, obtenidos por medio del registro, tales como: recolección, almacenamiento, uso, circulación, supresión, transferencia y transmisión de mis datos personales de acuerdo a las siguientes:</p>

                                <p>1. FINALIDADES</p>

                                <p>1.1 Realizar el registro para participar en los entrenamientos;</p>

                                <p>1.2 Iniciar comunicación con los participantes;</p>

                                <p>1.3 Identificar factores de riesgo y patologías que puedan comprometer la integridad personal de los participantes;</p>

                                <p>1.4 Creación de perfiles y características de los participantes en los cursos de LIFE C.E.L;</p>

                                <p>1.5 Remitir información promocional, publicitaria y de actualización sobre los servicios de LIFE C.E.L;</p>

                                <p>1.6  Para la atención de quejas, peticiones, reclamos, sugerencias, evaluación de los servicios prestados, y para otras finalidades relacionadas con los servicios que presta LIFE C.E.L.</p>

                                <p>2. DATOS SENSIBLES</p>

                                <p>He sido informado que no estoy obligado a responder datos sensibles. Entendiendo por tales los que afectan la intimidad del Titular o cuyo uso indebido puede generar su discriminación, tales como aquellos que revelen el origen racial o étnico, la orientación política, las convicciones religiosas o filosóficas, la pertenencia a sindicatos, organizaciones sociales, de derechos humanos o que promueva intereses de cualquier partido político o que garanticen los derechos y garantías de partidos políticos de oposición así como los datos relativos a la salud, a la vida sexual y los datos biométricos.</p>

                                <p>3. RESPONSABLE</p>

                                <p>El encargado y responsable del tratamiento de los datos personales es  LIFE CENTRO DE ENTRENAMIENTO EN LIDERAZGO CEL representada legalmente por Alejandro Ramírez Gómez, con domcilio principal en la circular 75 Nº 39B-30 edificio Zares, oficina 102, en la ciudad de Medellín, teléfono Nº 605-609-607.</p>

                                <p>4. DERECHOS</p>

                                <p>En mi calidad de títular de lo datos personales he sido informado de los derechos que me asisten, entre los cuales se hayan los que se relacionan:</p>

                                <p>4.1 Conocer, actualizar y rectificar sus datos personales frente a los Responsables del Tratamiento o Encargados del Tratamiento. Este derecho se podrá ejercer, entre otros frente a datos parciales, inexactos, incompletos, fraccionados, que induzcan a error, o aquellos cuyo Tratamiento esté expresamente prohibido o no haya sido autorizado;</p>

                                <p>4.2 Solicitar prueba de la autorización otorgada al Responsable del Tratamiento salvo cuando expresamente se exceptúe como requisito para el Tratamiento;</p>

                                <p>4.3 Ser informado por el Responsable del Tratamiento o el Encargado del Tratamiento, previa solicitud, respecto del uso que le ha dado a sus datos personales;</p>

                                <p>4.4 Presentar ante la Superintendencia de Industria y Comercio quejas por infracciones al tratamiento de datos;</p>

                                <p>4.5 Revocar la autorización y/o solicitar la supresión del dato cuando en el Tratamiento no se respeten los principios, derechos y garantías constitucionales y legales. La revocatoria y/o supresión procederá cuando la Superintendencia de Industria y Comercio haya determinado que en el Tratamiento el Responsable o Encargado han incurrido en conductas contrarias a la ley y a la Constitución;</p>

                                <p>4.6 Acceder en forma gratuita a sus datos personales que hayan sido objeto de Tratamiento.</p>
                            </div>
                            <div className="group-form">
                                <label>* Manifiesto que he leído las políticas sobre el tratamiento de datos de LIFE y estoy de acuerdo con ellas.
                                    De no estar de acuerdo con lo aquí mencionado, te invitamos a que te pongas en contacto con nosotros</label>
                            </div>
                            <div className="group-form">
                                <label className="ie-check" for="dataProcessing">
                                    <input type="checkbox" id="dataProcessing" name="dataProcessing" required className="form-control" /> <b>Acepto</b>
                                </label>
                            </div>
                            <div className="group-form">
                                <input type="button" value="Atrás" className="btn btn-cancel" />
                                <input type="button" value="Siguiente" onClick={context.nextTab.bind(context)} className="btn btn-primary" data-argument="tab2" />
                            </div>
                        </div>
                        <div id="tab3" class="tab-pane fade">
                            <div className="group-form">
                                <h3><b>CUESTIONARIO CONFIDENCIAL SOBRE SU SALUD</b></h3><br />

                                <p> El siguiente cuestionario es de carácter reservado y voluntario. El cual nos permitirá identificar factores de riesgo para su entrenamiento.
                                    La información que usted provee aquí permitirá que nuestros entrenadores y personal de apoyo le puedan brindar mejor servicio durante la participación en el entrenamiento. No obstante, LIFE C.E.L no puede predecir la experiencia que tendrá el participante. Si durante cualquier actividad se siente incómodo, infórmelo inmediatamente al entrenador o el personal de apoyo de LIFE C.E.L.</p>

                                <p>Si tiene alguna duda sobre lo apropiado de su participación, por favor consulte a un profesional de su confianza o con el cual se encuentre en algún tipo tratamiento. En algunos casos nosotros exigimos que lo haga  como requisito para participar en el entrenamiento.</p>
                            </div>
                            <div className="group-form">
                                <label>* Sexo</label><br />
                                <input type="radio" name="gender" className="form-control" value="Hombre" required /> Hombre<br />
                                <input type="radio" name="gender" className="form-control" value="Mujer" /> Mujer<br />
                                <input type="radio" name="gender" className="form-control" value="Otro" /> Otro
                            </div>
                            <div className="group-form">
                                <label>* ¿Estás embarazada?</label><br />
                                Si está en embarazo y se encuentra entre el primer o segundo trismestre requerimos que consulte con su médico antes de iniciar el entrenamiento. Si se encuentra en el tercer trimestre no podrá participar en el taller.<br />
                                <input type="radio" name="pregnant" className="form-control" value="Si" required /> Sí<br />
                                <input type="radio" name="pregnant" className="form-control" value="No" /> No<br />
                                <input type="radio" name="pregnant" className="form-control" value="Quiza" /> Tal vez<br />
                            </div>
                            <div className="group-form" id="optionSymptom">
                                <label>* ¿Has sufrido alguno de estos síntomas durante los últimos 8 días?</label>
                                <input type="text" required defaultValue={context.state.symthomSelected} style={{ opacity: '0' }} />
                                <br />

                                <input type="checkbox" name="optionSymptom" className="form-control" value="Fiebre" onClick={context.handleSymthom.bind(context)} /> Fiebre<br />
                                <input type="checkbox" name="optionSymptom" className="form-control" value="Dolor de garganta" onClick={context.handleSymthom.bind(context)} /> Dolor de garganta<br />
                                <input type="checkbox" name="optionSymptom" className="form-control" value="Congestión nasal" onClick={context.handleSymthom.bind(context)} /> Congestión nasal<br />
                                <input type="checkbox" name="optionSymptom" className="form-control" value="Tos" onClick={context.handleSymthom.bind(context)} /> Tos<br />
                                <input type="checkbox" name="optionSymptom" className="form-control" value="Dificultad para respirar" onClick={context.handleSymthom.bind(context)} /> Dificultad para respirar<br />
                                <input type="checkbox" name="optionSymptom" className="form-control" value="Fatiga" onClick={context.handleSymthom.bind(context)} /> Fatiga<br />
                                <input type="checkbox" name="optionSymptom" className="form-control" value="Escalofrío" onClick={context.handleSymthom.bind(context)} /> Escalofrío<br />
                                <input type="checkbox" name="optionSymptom" className="form-control" value="Dolor de músculos" onClick={context.handleSymthom.bind(context)} /> Dolor de músculos<br />
                                <input type="checkbox" name="optionSymptom" className="form-control" value="Ninguna de las anteriores" onClick={context.handleSymthom.bind(context)} /> Ninguna de las anteriores<br />
                                <input type="checkbox" name="optionSymptom" className="form-control" value="Otros" onClick={context.handleSymthom.bind(context)} /> Otros<br />

                                <input type="text" name="AnotherSymptom" className="form-control" maxLength="150" />
                            </div>
                            <div className="group-form" id="optionCovid">
                                <label>* Elige alguna de las opciones que se apliquen en tu caso</label>
                                <input type="text" required defaultValue={context.state.covidSelected} style={{ opacity: '0' }} />
                                <br />
                                <input type="checkbox" name="optionCovid" className="form-control" value="Estuve en contacto con alguien que tuvo alguno de esos síntomas" onClick={context.handleCovid.bind(context)} /> Estuve en contacto con alguien que tuvo alguno de esos síntomas<br />
                                <input type="checkbox" name="optionCovid" className="form-control" value="Hice un viaje internacional en los últimos 30 días" onClick={context.handleCovid.bind(context)} /> Hice un viaje internacional en los últimos 30 días<br />
                                <input type="checkbox" name="optionCovid" className="form-control" value="Hice un viaje nacional en los últimos 30 días" onClick={context.handleCovid.bind(context)} /> Hice un viaje nacional en los últimos 30 días<br />
                                <input type="checkbox" name="optionCovid" className="form-control" value="Soy trabajador de salud" onClick={context.handleCovid.bind(context)} /> Soy trabajador de salud<br />
                                <input type="checkbox" name="optionCovid" className="form-control" value="Ninguna de las anteriores" onClick={context.handleCovid.bind(context)} /> Ninguna de las anteriores<br />
                                <input type="checkbox" name="optionCovid" className="form-control" value="Otros" onClick={context.handleCovid.bind(context)} /> Otros<br />

                                <input type="text" name="anotherCovid" className="form-control" maxLength="150" />
                            </div>

                            <div className="group-form" id="optionVaccine">
                                <label>* ¿Estas vacunado con?</label>
                                <input type="text" required defaultValue={context.state.vaccine} style={{ opacity: '0' }} />
                                <br />
                                <input type="checkbox" name="optionVaccine" className="form-control" value="Pfizer" onClick={context.handleVaccine.bind(context)} /> Pfizer<br />
                                <input type="checkbox" name="optionVaccine" className="form-control" value="Moderna" onClick={context.handleVaccine.bind(context)} /> Moderna<br />
                                <input type="checkbox" name="optionVaccine" className="form-control" value="Astrazeneca" onClick={context.handleVaccine.bind(context)} /> Astrazeneca<br />
                                <input type="checkbox" name="optionVaccine" className="form-control" value="Janssen" onClick={context.handleVaccine.bind(context)} /> Janssen<br />
                                <input type="checkbox" name="optionVaccine" className="form-control" value="Ninguna" onClick={context.handleVaccine.bind(context)} /> Ninguna<br />
                                <input type="checkbox" name="optionVaccine" className="form-control" value="Otra" onClick={context.handleVaccine.bind(context)} /> Otra<br />

                                <input type="text" name="anotherVaccine" className="form-control" maxLength="150" />
                            </div>

                            <div className="group-form">
                                <label>* ¿Cuántas dosis tienes aplicadas?</label>
                                <input type="number" name="dosis" className="form-control" required maxLength="2" placeholder="Ingresa un valor numérico, ejemplo: 2" />
                            </div>

                            <div className="group-form">
                                <label>* ¿Cuántas horas duermes usualmente?</label>
                                <input type="number" name="sleep" className="form-control" required maxLength="2" />
                            </div>
                            <div className="group-form">
                                <label>* ¿Ha recibido consejería o terapia psicológica antes del último año?</label><br />
                                <input type="radio" name="therapyYearAgo" className="form-control" value="Si" required /> Sí<br />
                                <input type="radio" name="therapyYearAgo" className="form-control" value="No" /> No<br />
                            </div>
                            <div className="group-form">
                                <label>* ¿Recibe consejería o terapia psicológica en la actualidad?</label><br />
                                <input type="radio" name="currentTherapy" className="form-control" value="Si" required /> Sí<br />
                                <input type="radio" name="currentTherapy" className="form-control" value="No" /> No<br />
                            </div>
                            <div className="group-form">
                                <label>* ¿Ha sido hospitalizado para atender su salud mental?</label><br />
                                Si la respuesta es afirmativa ponte en contacto con nosotros<br />
                                <input type="radio" name="hospitalized" className="form-control" value="Si" required /> Sí<br />
                                <input type="radio" name="hospitalized" className="form-control" value="No" /> No<br />
                            </div>
                            <div className="group-form">
                                <label>* ¿Le han recetado alguna vez, o se encuentra actualmente tomando medicinas para el tratamiento de dolencias emocionales, tales como: compazine, haldol, navane, proxilin, prozac, stelazine, triavil?</label><br />

                                <input type="radio" name="takeMedication" className="form-control" value="Si" required /> Sí<br />
                                <input type="radio" name="takeMedication" className="form-control" value="No" /> No<br />
                                <input type="radio" name="takeMedication" className="form-control" value="Otro" /> Otros

                                <input type="text" name="anotherMedication" className="form-control" maxLength="150" />
                            </div>
                            <div className="group-form">
                                <label>* ¿Ha sufrido un colapso nervioso diagnosticado por un profesional de la salud?</label><br />

                                <input type="radio" name="nervousCollapse" className="form-control" value="Si" required /> Sí<br />
                                <input type="radio" name="nervousCollapse" className="form-control" value="No" /> No<br />
                                <input type="radio" name="nervousCollapse" className="form-control" value="Otro" /> Otros

                                <input type="text" name="anotherNervous" className="form-control" maxLength="150" />
                            </div>
                            <div className="group-form">
                                <label>* ¿Tiene alguna discapacidad física que pueda dificultar su participación en el entrenamiento? </label>
                                <input type="text" name="physicalDisability" className="form-control" maxLength="255" />
                            </div>
                            <div className="group-form">
                                IMPORTANTE...
                                Por la presente doy fe de que soy mayor de edad, y que he leído cuidadosamente el anterior cuestionario, asimismo, que la información suministrada es veraz y completa.
                            </div>
                            <div className="group-form">
                                <input type="button" value="Atrás" className="btn btn-cancel" />
                                <input type="button" value="Siguiente" onClick={context.nextTab.bind(context)} className="btn btn-primary" data-argument="tab3" />
                            </div>
                        </div>
                        <div id="tab4" class="tab-pane fade">
                            <div className="group-form">
                                <h4>POLÍTICAS DE MANEJO DE DINEROS LIFE CEL COLOMBIA</h4>
                            </div>
                            <div className="group-form">
                                <p>
                                    En LIFE CEL temenos diferentes modalidades de pago: FULL LIFE Y
                                    PROMO LIFE. Al momento de la inscripción el participante puede elegir
                                    cuál es la opción funcional. Cada una tiene diferentes beneficios y
                                    restricciones.
                                </p>
                            </div>
                            <div className="group-form">
                                <p><b>Tabla comparativa entre los valores de inscripción</b></p>
                                <p>
                                    Esta tabla representa los beneficios que tiene el tipo de pago que usted realizó, si tiene duda de cuál es su estado de
                                    pago puede preguntarle a nuestro coordinador.
                                </p>
                                <table className="responsive text-center">
                                    <thead>
                                        <tr>
                                            <td className="border col-lg-1">
                                                Beneficios
                                            </td>
                                            <td className="border col-lg-2">Transferencia
                                                de dinero
                                            </td>
                                            <td className="border col-lg-3"> Cambio de fecha para la
                                                misma cohorte
                                            </td>
                                            <td className="border col-lg-3"> Cambio de fecha
                                                hasta por 6 meses
                                                siguientes a la
                                                inscripción
                                            </td>
                                            <td className="border col-lg-3"> Devolución
                                                de dinero
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border">Full Life</td>
                                            <td className="border"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
                                                <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                                                <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                                            </svg></td>
                                            <td className="border"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
                                                <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                                                <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                                            </svg></td>
                                            <td className="border"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
                                                <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                                                <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                                            </svg></td>
                                            <td className="border"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
                                                <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                                                <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                                            </svg></td>
                                        </tr>
                                        <tr>
                                            <td className="border">Promo Life</td>
                                            <td className="border"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
                                                <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                                                <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                                            </svg></td>
                                            <td className="border"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
                                                <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                                                <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                                            </svg></td>
                                            <td className="border"></td>
                                            <td className="border"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="group-form">
                                <p><b>FULL LIFE</b></p>
                                <p>
                                    Es nuestro precio estrella. En esta modalidad el participante puede
                                    realizar transferencia de dineros a otros participantes inscritos, cambiar la
                                    fecha para realizar los entrenamientos en la misma cohorte, aplazar el
                                    entrenamiento, hasta por 6 meses siguientes a la inscripción, y solicitar la
                                    devolución del dinero en cualquier momento, sin justificaciones.
                                </p>

                                <p><b>PROMO LIFE</b></p>
                                <p>
                                    Es nuestra modalidad de precios especiales. El participante solo puede
                                    solicitar la transferencia de dineros o cambiar las fechas para la misma
                                    cohorte. No aplica el aplazamiento hasta por 6 meses o la devolución
                                    incondicional del dinero.
                                </p>
                            </div>
                            <div className="group-form">
                                <p><b>TRANSFERENCIA DE DINERO</b></p>
                                <p>
                                    El participante que no pueda o no quiera continuar con el entrenamiento
                                    podrá, hasta antes de iniciar el entrenamiento para el que fue inscrito,
                                    solicitar que el dinero pagado por concepto de matricula se transfiera a
                                    otro participante inscrito, para el mismo nivel de entrenamiento, de
                                    acuerdo con las siguientes condiciones:
                                </p>

                                <p>
                                    1.	La transferencia de dinero solo aplica para los entrenamientos activos
                                    en las mismas fechas a las que se inscribió inicialmente el
                                    participante.
                                </p>
                                <p>
                                    2.	El participante a quien se le transfiere el dinero debe estar inscrito.
                                </p>
                                <p>
                                    3.	Solamente se puede transferir dinero para entrenamientos de la
                                    misma categoría: básico a básico; avanzado a avanzado; PL a PL.
                                </p>
                                <p>
                                    La solicitud de transferencia de dinero se podrá hacer directamente a
                                    través del WhatsApp o por comunicación directa con el coordinador.
                                </p>

                                <p><b>CAMBIO DE FECHA</b></p>

                                <p>
                                    El participante puede cambiar de sede para realizar el entrenamiento,
                                    solamente para la misma cohorte. Sujeto a disponibilidad y restricciones
                                    de aforo para la sede que solicita el cambio. Para PROMO LIFE solo se
                                    puede pedir el cambio de fecha hasta antes de iniciar el entrenamiento.
                                    Para FULL LIFE se puede en cualquier momento, siempre y cuando no
                                    se afecte el desarrollo del entrenamiento.
                                </p>

                                <p><b>CAMBIO DE FECHA HASTA POR 6 MESES</b></p>
                                <p>
                                    Los participantes que hayan pagado FULL LIFE pueden aplazar el inicio
                                    del entrenamiento hasta por 6 meses, contados a partir de la inscripción.
                                </p>

                                <p><b>DEVOLUCIÓN DE DINERO</b></p>
                                <p>
                                    Cuando LIFE C.E.L cancele el entrenamiento por no haber alcanzado el
                                    número mínimo de participantes devolverá el 100% del dinero pagado. El
                                    reintegro se realizará dentro de los 5 días hábiles siguientes a la
                                    cancelación del entrenamiento, por el medio que indique el participante.
                                    Si el entrenamiento se cancela por el hecho de un tercero, caso fortuito o
                                    fuerza mayor, LIFE CEL reprogramará el entrenamiento.
                                </p>

                                <p>
                                    Después de que haya iniciado el entrenamiento no habrá lugar a ningún
                                    tipo devolución de dinero, ni transferencia de dinero, ni cambio de
                                    fechas. Para la modalidad FULL LIFE se puede solicitar la devolución
                                    completa del dinero, en cualquier momento.
                                </p>
                                <p>
                                    El participante solo puede ejercer el derecho al retracto cuando el
                                    entrenamiento se haya convenido por medio de alguna de las
                                    modalidades <b>previstas en el artículo 47 de la Ley 1480 de 2011.</b>
                                </p>
                                <p>
                                    El consumidor no podrá́ ejercer el derecho de retracto cuando el servicio
                                    haya comenzado a prestarse con su consentimiento o cuando entre el
                                    momento en que se ejerza el derecho de retracto y la fecha pactada para
                                    el inicio de la prestación del servicio medien menos de cinco (5) días.
                                </p>
                                <p>
                                    El término máximo para ejercer el derecho de retracto será́ de cinco (5)
                                    días hábiles contados a partir de la celebración del contrato en caso de la
                                    prestación de servicios. Si procede el derecho al retracto, se devolverán
                                    todas las sumas pagadas. Sin exceder (30) días calendario desde el
                                    momento en que ejerció el derecho.
                                </p>
                                <p>
                                    Manifiesto que el presente documento lo tuve a mi disposición durante
                                    el tiempo que estimé necesario. Cada uno de los párrafos los comprendí,
                                    y el equipo de LIFE CEL estuvo atento para responder todas mis
                                    preguntas, inquietudes y sugerencias.
                                </p>
                            </div>
                            <div className="group-form">
                                <label className="ie-check" for="moneyPolicy">
                                    <input type="checkbox" id="moneyPolicy" name="moneyPolicy" required className="form-control" /> <b>Acepto</b>
                                </label>
                            </div>
                            <div className="group-form">
                                <input type="button" value="Atrás" className="btn btn-cancel" />
                                <input type="button" value="Siguiente" onClick={context.nextTab.bind(context)} className="btn btn-primary" data-argument="tab4" />
                            </div>
                        </div>
                        <div id="tab5" class="tab-pane fade">
                            <div className="group-form">
                                <h3><b>ASPECTOS LEGALES</b></h3>
                            </div>
                            <div className="group-form">
                                Lea detenidamente toda la información. Si tienes alguna duda ponte en contacto con nosotros.
                            </div>
                            <div className="group-form">
                                <p>
                                    LIFE CEL responderá por los perjuicios patrimoniales y extrapatrimoniales que sean
                                    consecuencia directa de mi participación en los entrenamientos y se hayan producido por las
                                    acciones dolosas de sus trabajadores.
                                </p>

                                <p>
                                    Declaro que me encuentro en condiciones de salud mental y física para participar en el
                                    entrenamiento de LIFE C.E.L, y que no presento ningún tipo de patología que me impida
                                    participar. Asimismo, que toda la información que le he suministrado a LIFE C.E.L sobre mi
                                    salud mental y física es totalmente fidedigna.
                                </p>

                                <p>
                                    LIFE CEL no custodia mis pertenencias. Es mi responsabilidad vigilarlas. Cualquier daño,
                                    pérdida o hurto de mis pertenencias no es responsabilidad de LIFE CEL, salvo que haya
                                    actuado con dolo.
                                </p>

                                <p>
                                    Comprendo y acepto que en el entrenamiento puede haber algunas actividades con riesgos
                                    para mi integridad personal, tanto en lo corporal como mental. Riesgos como subir y bajar
                                    escalas, caminar o correr sobre terreno irregular, actividades de contacto corporal con otros
                                    participantes, caminar o correr sobre superficies con agua, superar obstáculos ubicados
                                    horizontalmente, caídas, excoriaciones, lesiones por mecanismos cortantes, punzantes,
                                    contundentes, cortocontundenes, cortopunzantes, enfermedades, infecciones y los riesgos
                                    derivados de los efectos del tiempo y del ambiente, como frio, calor, humedad relativa, etc.
                                    Estos riesgos, y los que resultan directa o indirectamente y estén relacionados con las
                                    actividades que programa LIFE C.E.L los asumo de manera consciente, libre y voluntaria. En
                                    todo momento puedo negarme a realizar cualquier actividad. Si después de que me hayan
                                    explicado la actividad y haya podido evaluar los potenciales riesgos para mi integridad
                                    personal decido no asumirlos, la decisión será respetada por LICE CEL. Entiendo y acepto
                                    que durante el entrenamiento o como consecuencia de este, puedo sufrir daños causados por
                                    mi, otro participante, un tercero, o por eventos de caso fortuito y/o fuerza mayor de los cuales
                                    se pueden derivar perjuicios patrimoniales y extrapatrimoniales. Perjuicios por los cuales no es
                                    responsable LIFE CEL.
                                </p>

                                <p>
                                    Entiendo y acepto que para poder participar en los entrenamientos de LIFE CEL debo contar
                                    con cobertura en salud, ya sea de un sistema público o privado, que garantice mi atención en
                                    salud por cualquier daño personal que sufra durante los entrenamientos, o con ocasión de
                                    estos.
                                </p>

                                <p>
                                    Declaro que en todo momento he tenido la posibilidad de solicitar que la información sea
                                    aclarada o ampliada por parte de LIFE C.E.L. Además, que toda la información suministrada
                                    es veraz y completa. Comprendo que LIFE C.E.L únicamente ofrece un programa con base
                                    en experiencias filosóficas y educacionales que puede o no ayudarme en mi crecimiento
                                    personal. No tiene la intención de ser psicoterapia, terapia médica o un sustituto de cualquiera
                                    de ellas. También que varias de las actividades conllevan emociones profundas, estrés
                                    emocional, y quizás llanto, ansiedad, incomodidad física y otros efectos mentales.
                                </p>

                                <p>
                                    Manifiesto de forma voluntaria, informada y libre que acepto participar en el entrenamiento de
                                    LIFE C.E.L.
                                </p>
                            </div>
                            <div className="group-form">
                                <label>* ¿ACEPTA que ha leído de manera íntegra el documento, y que además de comprenderlo acepta cada uno de los términos y condiciones del mismo?</label>
                            </div>
                            <div className="group-form">
                                <label className="ie-check" for="acceptedTerms">
                                    <input type="checkbox" name="acceptedTerms" id="acceptedTerms" required className="form-control" /> <b>Acepto</b>
                                </label>
                            </div>
                            <div className="group-form">
                                <h4><b><p>CONSENTIMIENTO INFORMADO...</p></b></h4>
                                <p>Yo, como participante inscrito en el Entrenamiento en Liderazgo, mayor de edad, y en pleno uso de mis condiciones mentales y físicas, suficientemente informado(a), de manera libre y voluntaria conozco y acepto las RECOMENDACIONES, REGLAS, TRATAMIENTO DE DATOS, CUESTIONARIO SOBRE SALUD, EXONERACIÓN DE RESPONSABILIDAD Y ACUERDO DE PROPIEDAD INTELECTUAL.</p>

                                <p>Declaro que en todo momento he tenido la posibilidad de que la información me sea aclarada o ampliada por parte de LIFE C.E.L. Además, que toda la información suministrada es veraz y completa.
                                    Asimismo, comprendo que LIFE C.E.L únicamente ofrece un programa con base en experiencias filosóficas y educacionales que puede o no ayudarme en mi crecimiento personal. No tiene la intención de ser psicoterapia, terapia médica o un sustituto de cualquiera de ellas. También que varias de las actividades conllevan emociones profundas, estrés emocional, y quizás llanto, ansiedad, incomodidad física y otros efectos mentales.</p>

                            </div>
                            <div className="group-form">
                                <label>* Por todo lo anterior ACEPTO PARTICIPAR en el ENTRENAMIENTO DE LIFE C.E.L.</label>
                            </div>
                            <div className="group-form">
                                <label className="ie-check" for="acceptParticipe">
                                    <input type="checkbox" name="acceptParticipe" id="acceptParticipe" required className="form-control" /> <b>Acepto</b>
                                </label>
                            </div>

                            <div className="group-form">
                                <label>TIENES ALGUNA PREGUNTA O INQUIETUD...</label>
                                <input type="text" name="questions" className="form-control" />
                            </div>
                            <div className="group-form">
                                BIENVENIDO A NUESTRO ENTRENAMIENTO BASICO
                                Ya pronto estarás viviendo una experiencia única!
                            </div>
                            <div className="group-form">
                                <input type="button" value="Atrás" className="btn btn-cancel" />
                                <input type="button" value="Enviar" onClick={context.sendInfo.bind(context)} className="btn btn-primary" data-argument="tab5" />
                            </div>
                        </div>
                    </div>
                </div >
            )
        }
    }

    async openModalPayments(e) {
        this.setState({ clientId: parseInt(e.currentTarget.dataset.value) });
    }

    render() {
        //let content = this.state.loading ? <h2>Cargando...</h2> : RegistrationForm.renderForm(this.state.data, this);
        let content = RegistrationForm.renderForm(this.state.data, this);
        return <div>

            {this.state.loading ?

                <div className="loading">
                    <div class="spinner-grow" role="status">
                    </div>
                    <span className="text">Cargando...</span>
                </div>

                : null}

            {content}

            <div class="form-group">
                {document.querySelector("#sesionAdmin") && this.state.currentForm != 'Registro' && this.state.currentForm != 'Basico' ? <a onClick={this.openModalPayments.bind(this)} data-value={this.state.data ? this.state.data.id : -1}><span className="action btn paying"></span>Adicionar pago</a> : null}
            </div>


            {this.state.clientId > -1 ? <PaymentHistory ClientId={this.state.clientId} ResetClient={() => { this.setState({ clientId: -1 }) }} /> : null}
        </div>
    }

}